import styled from "styled-components";

export const Container = styled.section`
  padding-top: 15%;
  display: flex;
  justify-content: space-between;
  gap: 8rem;
  background: rgba(0,0,0,0);
  .hero-text{
    & > p{
      font-size: 1.8rem;
    }
    h1{
      font-size: 7rem;
    }

    h3{
      color:var(--green);
      margin: 1rem 0;
    }

    
    p.small-resume {
      margin-bottom: 5rem;
    }
  }
// New added
  .social-media{
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding-top:5rem;
    padding-left:1rem;

    img,span{
      font-size: 3rem;
      width: 3.5rem;
    }

    a:nth-child(2) img {
      width: 3rem;
      height: 3rem;
    }
  }


  .button{
    margin-top: 5rem;
    padding: 1.4rem 6rem;
  }

  .hero-image{
    transform: translateX(-50px);
    
    img{
      max-width: 1000px;
      max-height: 1300px;
    }
  }


  @media(max-width: 960px){
    display: block;
    margin-top: 15%;
    .hero-text{

      h1{
        font-size: 5rem;
      }
    }
    
    .hero-image{
      display: flex;
      justify-content: center;
      margin-top: 4rem;
      transform: translateX(0);
      
      img{
        max-width: 80%;
        max-height: 500px;
        width: 100%;
        height: auto;
      }
    }
  }

  @media(max-width: 600px){
    margin-top: 35%;
    
    .hero-image{
      img{
        max-width: 90%;
        max-height: 400px;
      }
    }
  }
  @media(max-width: 480px){
    margin-top: 45%;
    
    .hero-image{
      img{
        max-width: 95%;
        max-height: 350px;
      }
    }
  }
`